import { auth } from '../firebase/config';

class EmailService {
  constructor() {
    // Check if we're in development by looking at the URL
    const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

    // Check for URL parameter override (e.g., ?useRemoteAPIs=true)
    const urlParams = new URLSearchParams(window.location.search);
    const useRemoteAPIs = urlParams.get('useRemoteAPIs') === 'true';

    const envSuffix = import.meta.env.PROD ? 'prod' : 'dev';
    this.apiUrl = (isDevelopment && !useRemoteAPIs)
      ? 'http://localhost:8004'  // Local email service API
      : `https://email-service-api-${envSuffix}.blackbay-6bd764e8.eastus2.azurecontainerapps.io`;
  }

  /**
   * Send feedback email
   */
  async sendFeedbackEmail(email, title, message) {
    try {
      const user = auth.currentUser;
      const idToken = user ? await user.getIdToken() : null;

      const headers = { 'Content-Type': 'application/json' };
      if (idToken) {
        headers['X-Firebase-Token'] = idToken;
      }

      const response = await fetch(`${this.apiUrl}/api/feedback`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          email,
          title,
          message,
          to_email: 'contact@splitstep.ai',
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `API call failed: ${response.status}`);
      }

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.error || 'Failed to send feedback email');
      }

      return result;

    } catch (error) {
      console.error('Feedback email failed:', error);
      throw error;
    }
  }
}

// Export singleton instance
export const emailService = new EmailService();

